
import { FaPollH } from "react-icons/fa";

export const dailyReviews = [
    {
        title: 'Transactions',
        'successful': 12000000,
        'failed': 10,
        'icon': 'trans'
    },
    {
        title: 'Sales',
        'amount': 12000000, 
        'icon': 'sales'
    },
    {
        title: 'Sales Profit Average',
        'amount': 12000000, 
        'icon': 'sProfit'
    },
    {
        title: 'Fund Profit Average',
        'amount': 12000000, 
        'icon': 'fProfit'
    },

];

export const overallReviews = [
    
    {
        title: 'Users',
        'amount': 12000000, 
    },
    {
        title: 'Transactions',
        'successful': 12000000,
        'failed': 10
    },
    {
        title: 'Total Sales',
        'amount': 12000000, 
    },
    {
        title: 'Total Sales Profit Average',
        'amount': 12000000, 
    },
    {
        title: 'Total Fund Profit Average',
        'amount': 12000000, 
    },
    {
        title: 'Total Payments',
        'amount': 12000000, 
    },
    {
        title: 'Users Balance',
        'amount': 12000000, 
    },
];
